import { AxiosError } from 'axios';
import type { ApiError } from '@tracker/shared';

/** Extracts the human-readable message from a backend error envelope. */
export function getErrorMessage(e: unknown): string {
  return (e as AxiosError<ApiError>).response?.data?.error?.message ?? 'Something went wrong';
}
